import {isBlobLike} from "#browser-utils/blob"
import type {CmLogger} from "@cm/log"
import {wrapLogger} from "@cm/log"
import {graphToJson as platformIndependentGraphToJson, jsonToGraph as platformIndependentJsonToGraph} from "@cm/utils"

const defaultLogger = wrapLogger(console)

export const graphToJson = (graph: unknown, logger?: CmLogger) => platformIndependentGraphToJson(graph, logger ?? defaultLogger)
export const jsonToGraph = (json: unknown, logger?: CmLogger) => platformIndependentJsonToGraph(json, isBlobLike, logger ?? defaultLogger)
